import React, { useState, useEffect, useCallback } from 'react'
import { useTranslate } from 'react-admin'
import { ShowCard, CompleteSideCard } from 'src/components/uiElements/cards/ShowCard'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { useQuery } from 'react-query'
import { Box, Grid } from '@mui/material'
import { CounterCard } from 'src/components/pages/dashboard/logic/CounterCard'
import { ExchangeTypeCard } from 'src/components/pages/dashboard/logic/ExchangeTypeCard'
import AirNetviaxTicketsList from './AirNetviaxTicketsList'
import AirStarlingsTicketsList from './AirStarlingsTicketsList'
import LastSalesList from './LastSalesList'
import { PERMISSION_LIST_SHOW } from 'src/helper/Permission'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import RefreshIcon from '@mui/icons-material/Refresh'

export const DashboardSales = () => {
  const translate = useTranslate()
  const [count, setCount] = useState(0)
  const [triggerLoadingStarling, setTriggerLoadingStarling] = useState(false)

  const maxCount = 999

  const guaranteedSales = useQuery('guaranteed-sales', () =>
    reservationServices.getByReservationByPaymentStatus('GUARANTEED')
  )
  const pendingSales = useQuery('pending-sales', () =>
    reservationServices.getByReservationByPaymentStatus('UNPAID')
  )
  const paidSales = useQuery('paid-sales', () => reservationServices.getByReservationByPaymentStatus('PAID'))

  const incrementCount = useCallback(() => {
    setCount((prevCount) => {
      if (prevCount < maxCount) {
        return prevCount + 1
      } else {
        return 0
      }
    })
  }, [maxCount])

  useEffect(() => {
    let timer
    if (paidSales.isLoading || pendingSales.isLoading || guaranteedSales.isLoading) {
      timer = setInterval(incrementCount, 100)
    }

    return () => {
      clearInterval(timer)
    }
  }, [incrementCount, paidSales.isLoading, pendingSales.isLoading, guaranteedSales.isLoading])

  return (
    <Box style={{ paddingRight: '100px', paddingLeft: '100px' }}>
      <ExchangeTypeCard />
      <Grid container spacing={1}>
        <Grid item xs={12} md={8} lg={12} xl={8}>
          <ShowCard title={translate('ra.title.last_sales')}>
            <CompleteSideCard>
              <LastSalesList />
            </CompleteSideCard>
          </ShowCard>
          {/* {hasPermissionFunction('air_tickets', PERMISSION_LIST_SHOW) && (
            <ShowCard title={translate('ra.title.air_tickets', {name: 'Netviax'})}>
              <CompleteSideCard>
                <AirNetviaxTicketsList />
              </CompleteSideCard>
            </ShowCard>
          )} */}
          {hasPermissionFunction('air-import', PERMISSION_LIST_SHOW) && (
            <ShowCard
              title={translate('ra.title.air_tickets', { name: 'Starlings' })}
              actionButtonText={translate('ra.action.refresh_data')}
              actionButtonIcon={<RefreshIcon />}
              actionButtonLoading={triggerLoadingStarling}
              onClickButton={() => setTriggerLoadingStarling(true)}
              avoidPermission={true}
            >
              <CompleteSideCard>
                <AirStarlingsTicketsList
                  refreshData={triggerLoadingStarling}
                  handleFinishRefresh={() => setTriggerLoadingStarling(false)}
                />
              </CompleteSideCard>
            </ShowCard>
          )}
        </Grid>

        <Grid item xs={4} md={4} lg={6} xl={4}>
          <ShowCard title={translate('ra.title.sales_with_guaranteed_payment')}>
            <CounterCard
              count={guaranteedSales.data === undefined ? count : guaranteedSales.data}
              isLoading={guaranteedSales.isLoading}
              border={'20px solid #78DCDC'}
              redirectTo={
                'reservation?displayedFilters=%7B%22item__payment_status%22%3Atrue%7D&filter=%7B%22item__payment_status__in%22%3A%5B%22GUARANTEED%22%5D%7D&order=DESC&page=1&perPage=10&sort=id'
              }
            />
          </ShowCard>

          <ShowCard title={translate('ra.title.sales_with_pending_payment')}>
            <CounterCard
              count={pendingSales.data === undefined ? count : pendingSales.data}
              isLoading={pendingSales.isLoading}
              border={'20px solid #FFD862'}
              redirectTo={
                'reservation?displayedFilters=%7B"item__payment_status"%3Atrue%7D&filter=%7B"item__payment_status__in"%3A%5B"PENDING"%5D%7D&order=DESC&page=1&perPage=10&sort=id'
              }
            />
          </ShowCard>

          <ShowCard title={translate('ra.title.sales_with_paid_payment')}>
            <CounterCard
              count={paidSales.data === undefined ? count : paidSales.data}
              isLoading={paidSales.isLoading}
              border={'20px solid #A9DC62'}
              redirectTo={
                'reservation?displayedFilters=%7B"item__payment_status"%3Atrue%7D&filter=%7B"item__payment_status__in"%3A%5B"PAID"%5D%7D&order=DESC&page=1&perPage=10&sort=id'
              }
            />
          </ShowCard>
        </Grid>
      </Grid>
    </Box>
  )
}
